import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { withRouter, useParams } from 'react-router-dom';
import get from 'lodash/get';
import moment from 'moment';

import { getDiasporaDetail } from '../action';

import './style.scss';

const DetailDiaspora = ({ history, registerDetail, getDiasporaDetail }) => {
  const { id } = useParams();
  const data = get(registerDetail, ['data', 'data']);

  const details = [
    { value: get(data, ['name']), label: 'Nama' },
    {
      value: `${get(data, ['birth_city'])} ${moment(get(data, ['birth_date'])).format(
        'DD MMM YYYY'
      )}`,
      label: 'Tempat, Tanggal Lahir'
    },
    { value: get(data, ['occupation']), label: 'Pekerjaan' },
    { value: get(data, ['organization']), label: 'Organisasi/Afiliasi' },
    { value: get(data, ['phone']), label: 'Phone Number' },
    { value: get(data, ['email']), label: 'Email Address' },
    { value: get(data, ['address']), label: 'Street Address' }
  ];

  useEffect(() => {
    getDiasporaDetail(id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className='detail-pengaduan'>
      <span className='back-homepage' onClick={() => history.goBack()}>
        <span className='btn-back' />
        Detail Diaspora
      </span>
      <div className='detail-pengaduan-content'>
        <div className='title'>Detail Diaspora</div>
        <table>
          {details.map(({ label, value }, key) => (
            <tr key={key}>
              <td>{label}</td>
              <td>{value || '-'}</td>
            </tr>
          ))}
        </table>
      </div>
    </div>
  );
};

DetailDiaspora.propTypes = {
  history: PropTypes.any,
  registerDetail: PropTypes.object,
  getDiasporaDetail: PropTypes.func
};

const mapStateToProps = (state) => ({
  registerDetail: {
    status: state.getDiasporaDetailReducer.status,
    error: state.getDiasporaDetailReducer.error,
    data: state.getDiasporaDetailReducer.data
  }
});

export default compose(
  connect(mapStateToProps, {
    getDiasporaDetail
  }),
  withRouter
)(DetailDiaspora);
